import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const checkEligibilityStatusEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ELIGIBLITY_STATUS,
    });
};

export const onCredPayClickEvent = (
    methodName: string,
    frictionLayoutId: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        context: `${methodName},${frictionLayoutId}`,
        action: CLICK_ACTIONS.CLICK_CRED_PAY,
    });
};

export const onCredPayButtonClickEvent = (
    methodName: string,
    frictionLayoutId: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        context: `${methodName},${frictionLayoutId}`,
        action: CLICK_ACTIONS.CLICK_PAY_BUTTON,
    });
};
